/**
 * Generated by orval 🍺
 * Do not edit manually.
 * Backoffice API Gateway
 * OpenAPI spec version: 1.0.0
 */
import type { AccountMeterpointsStructure, Meterpoint } from "../model"

import { backofficeRequest } from "../../client"

type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1]

/**
 * @summary Account's Meterpoints
 */
export const getAccountMeterpoints = (
  accountId: number,
  options?: SecondParameter<typeof backofficeRequest<Meterpoint[]>>,
) => {
  return backofficeRequest<Meterpoint[]>(
    { url: `/accounts/${accountId}/meterpoints`, method: "GET" },
    options,
  )
}
/**
 * @summary Accounts' Meterpoint Structure including meters, registers and readings
 */
export const getAccountMeterpointsStructure = (
  accountNumber: string,
  options?: SecondParameter<
    typeof backofficeRequest<AccountMeterpointsStructure[]>
  >,
) => {
  return backofficeRequest<AccountMeterpointsStructure[]>(
    { url: `/accounts/${accountNumber}/account_meterpoints`, method: "GET" },
    options,
  )
}
export type GetAccountMeterpointsResult = NonNullable<
  Awaited<ReturnType<typeof getAccountMeterpoints>>
>
export type GetAccountMeterpointsStructureResult = NonNullable<
  Awaited<ReturnType<typeof getAccountMeterpointsStructure>>
>
